import type { TeamRole as GQLTeamRole } from '@/generated/graphql';
import { take } from '@/helpers/takePayload';

export interface TeamRole {
  id?: number;
  name?: string;
}

export const getNew = (): TeamRole => ({});

export const fromGql = (gqlTeamRole: GQLTeamRole): TeamRole => ({
  ...(take(gqlTeamRole, 'id', 'name') as TeamRole),
});
